// captchaUtil.js
export function generateCaptcha() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let captcha = "";

  // Generate 6-character CAPTCHA
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    captcha += characters[randomIndex];
  }

  return captcha;
}

export const generateCaptchaImage = (captchaText) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 150; // Set width
  canvas.height = 50; // Set height

  // Draw background
  ctx.fillStyle = "#f0f0f0"; // Background color
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Draw text
  ctx.fillStyle = "#333"; // Text color
  ctx.font = "24px Arial";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(captchaText, canvas.width / 2, canvas.height / 2);

  // Return the image data URL
  return canvas.toDataURL("image/png");
};
